

document.addEventListener('DOMContentLoaded', function () {
    const el = document.getElementById('delivery-message');
    if (!el) return;

    function checkWeek(now) {
        const diaSemana = now.getDay(); // 0 domingo
        return diaSemana >= 1 && diaSemana <= 5; // lunes a viernes
    }

    function updateCountdown(targetTime, destinoTexto) {
        const now = new Date();
        let timeDifference = targetTime.getTime() - now.getTime();
        timeDifference = Math.max(timeDifference, 0);

        const horasFaltantes = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutosFaltantes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const segundosFaltantes = Math.floor((timeDifference % (1000 * 60)) / 1000);

        el.innerHTML =
            "Si compras ahora tu pedido llegará " + destinoTexto + ".<br>" +
            "Compra dentro de <span class='remaining-time'>" +
            Math.abs(horasFaltantes) + " horas, " +
            Math.abs(minutosFaltantes) + " minutos, y " +
            Math.abs(segundosFaltantes) + " segundos</span>";
    }

    function deliveryMessage() {
        const now = new Date();
        const cutOffTimeToday = new Date();
        cutOffTimeToday.setHours(12, 0, 0, 0); // hora de corte de HOY

        if (checkWeek(now)) {
            // Lunes a viernes
            if (now.getDay() === 5 && now.getTime() > cutOffTimeToday.getTime()) {
                // Viernes después del corte → próximo lunes
                const monday = new Date(now);
                // avanzar hasta el lunes siguiente
                monday.setDate(now.getDate() + ((8 - now.getDay()) % 7));
                monday.setHours(12, 0, 0, 0);

                updateCountdown(monday, "el Lunes");
                setInterval(() => updateCountdown(monday, "el Lunes"), 1000);
            } else if (now.getTime() < cutOffTimeToday.getTime()) {
                // Día laboral antes del cutoff → llega hoy
                updateCountdown(cutOffTimeToday, "hoy");
                setInterval(() => updateCountdown(cutOffTimeToday, "hoy"), 1000);
            } else {
                // Lunes–jueves después del corte → llega mañana (sin contador o con otro)
                el.innerHTML = 'Si compras hoy tu pedido llega <span class="remaining-time">mañana</span>';
            }
        } else {
            // Fin de semana → cuenta hasta el lunes 12:00
            const monday = new Date(now);
            monday.setDate(now.getDate() + ((8 - now.getDay()) % 7)); // siguiente lunes
            monday.setHours(12, 0, 0, 0);

            updateCountdown(monday, "el Lunes");
            setInterval(() => updateCountdown(monday, "el Lunes"), 1000);
        }
    }

    deliveryMessage();
});


